import * as React from "react";
import { HeartIcon as HeartOutlineIcon } from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolidIcon } from "@heroicons/react/24/solid";
import { RLink } from "./RLink";

export type HeartButtonProps = {
  liked: boolean;
  count: number;
  disabled?: boolean;
  onClick?: () => void;
  testId?: string;
  countTestId?: string;
  entryId?: number;
};

export const HeartButton = ({
  liked,
  count,
  disabled,
  onClick,
  testId,
  countTestId,
  entryId,
}: HeartButtonProps): JSX.Element => {
  const Icon = liked ? HeartSolidIcon : HeartOutlineIcon;

  const countElement = entryId ? (
    <RLink
      to={`/entry/${entryId}/favorites`}
      data-testid={countTestId}
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      variant="secondary"
      noUnderline
    >
      {count.toLocaleString()}
    </RLink>
  ) : (
    <span data-testid={countTestId}>{count.toLocaleString()}</span>
  );

  if (disabled) {
    return (
      <span className="inline-flex cursor-pointer items-center gap-1.5 rounded-full bg-slate-100 px-2 py-1 text-sm font-medium text-slate-400 dark:bg-slate-800 dark:text-slate-400">
        <HeartOutlineIcon className="h-4 w-4" aria-hidden="true" />
        {countElement}
      </span>
    );
  }

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={`inline-flex cursor-pointer items-center gap-1.5 rounded-full px-2 py-1 text-sm font-medium transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
        liked
          ? "bg-[#ff3c3c]/10 text-[#ff3c3c] hover:bg-[#ff3c3c]/20 focus-visible:outline-[#ff3c3c]"
          : "bg-slate-100 text-slate-400 hover:bg-slate-200 hover:text-slate-500 dark:bg-slate-800 dark:text-slate-400 dark:hover:bg-slate-700"
      }`}
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
      {countElement}
    </button>
  );
};
